import style from "./Flex.module.css";
import clsx from "classnames";
import { cloneElement, Children } from "react";
import React from "react";

function VerticalFlex(props) {
    const childrenWithProps = Children.map(props.children, child => {
        if (!React.isValidElement(child)) return child;

        const isDOMElement = typeof child.type === 'string';

        const extraProps = isDOMElement ? {} : {
            parentClass: "vertical",
            flexStart: props.flexStart ?? null
        };

        return React.cloneElement(child, extraProps);
    });
    return (
        <div className={clsx(style.flex, style.vertical)}
            style={
                {
                    width: (props.width ? props.width : null),
                    height: (props.height ? props.height : null),
                    padding: (props.padding ? props.padding : null),
                    overflow: (props.overflow ? props.overflow : null),
                    overflowX: (props.overflowX ? props.overflowX : props.overflow),
                    overflowY: (props.overflowY ? props.overflowY : props.overflow),
                    gap: (props.gap ? props.gap : null),
                    alignItems: (props.alignItems ? props.alignItems : props.flexStart?"flex-start":"center"),
                    justifyContent: (props.justifyContent ? props.justifyContent : "flex-start"),
                    backgroundImage: props.backgroundImage? `url(${props.backgroundImage})`:null,
                    backgroundColor : props.backgroundColor?props.backgroundColor:"transparent",
                    boxShadow: props.boxShadow ? props.boxShadow : null,
                    flexDirection: props.flexDirection ? props.flexDirection : null,
                }
            }>
            {childrenWithProps}
        </div>
    );
}

export default VerticalFlex;